import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';

import { parseCustomFiltersToObject, parseCustomFiltersToUrl } from 'Util/Url';

import CategoryPriceSlider from './CategoryPriceSlider.component';

/** @namespace AdvoxBasic/Component/CategoryPriceSlider/Container/CategoryPriceSliderContainer */
export class CategoryPriceSliderContainer extends PureComponent {
    static propTypes = {
        min: PropTypes.number.isRequired,
        max: PropTypes.number.isRequired,
    };

    state = {
        minAvailable: 0,
        maxAvailable: 0,
        valuesRange: [0, 0],
    };

    containerFunctions = {
        handleChangeSlider: this.handleChangeSlider.bind(this),
        handleChangeInputMin: this.handleChangeInputMin.bind(this),
        handleChangeInputMax: this.handleChangeInputMax.bind(this),
        handleButtonClick: this.handleButtonClick.bind(this),
    };

    componentDidMount() {
        const { min, max } = this.props;
        this.setState({
            minAvailable: min,
            maxAvailable: max,
            valuesRange: [min, max],
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const { min, max } = this.props;
        const prevMin = prevState.minAvailable;
        const prevMax = prevState.maxAvailable;

        const { location } = this.props;
        const { price } = parseCustomFiltersToObject(location);

        if (!price && (min !== prevMin || max !== prevMax)) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                minAvailable: min,
                maxAvailable: max,
                valuesRange: [min, max],
            });
        }
    }

    containerProps = () => {
        const { minAvailable, maxAvailable, valuesRange } = this.state;
        return {
            minAvailable,
            maxAvailable,
            valuesRange,
        };
    };

    handleChangeSlider(e, newVal) {
        if (newVal && newVal.length) {
            this.setState({ valuesRange: newVal });
        }
    }

    handleChangeInputMin(e) {
        const { valuesRange } = this.state;
        this.setState({ valuesRange: [+e.target.value, valuesRange[1]] });
    }

    handleChangeInputMax(e) {
        const { valuesRange } = this.state;
        this.setState({ valuesRange: [valuesRange[0], +e.target.value] });
    }

    handleButtonClick() {
        const { valuesRange } = this.state;
        const { location, history } = this.props;
        const priceString = `${valuesRange[0]}_${valuesRange[1]}`;
        const filtersFromUrl = parseCustomFiltersToObject(location);
        const newFilters = {
            ...filtersFromUrl,
            price: priceString,
        };
        const newUrl = parseCustomFiltersToUrl(newFilters);
        history.push({
            ...location,
            search: `?customFilters=${newUrl}`,
        });
    }

    render() {
        return <CategoryPriceSlider {...this.containerFunctions} {...this.containerProps()} />;
    }
}

export default withRouter(CategoryPriceSliderContainer);
